import { Form, Radio } from 'antd';
import { useTranslation } from 'react-i18next';

import { AddMinimizerOptions } from '../SinkInfoModal/SinkInfoModal.component';
import * as St from './ChipMinimizerInfoContent.styles';

import { IMAGE_COMING_SOON } from '~/core/constants';
import { OptionalProduct } from '~/core/models';
import { formatPriceUnitOrFree, imgUrl } from '~/core/utils';
import CommonRadio from '~atoms/CommonRadio';

type ChipMinimizerInfoContentProps = {
  chipMinimizer?: OptionalProduct;
  setMinimizerOption: (value: AddMinimizerOptions) => void;
};

const ChipMinimizerInfoContent = ({
  chipMinimizer,
  setMinimizerOption,
}: ChipMinimizerInfoContentProps) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  return (
    <St.Container>
      <St.Title>CHIP MINIMIZER</St.Title>
      <St.PriceWrapper>
        <St.ImageWrapper>
          <St.Price>
            {formatPriceUnitOrFree(chipMinimizer?.price, null, true)}
          </St.Price>
          <St.Image
            src={imgUrl(chipMinimizer?.imageUrl || IMAGE_COMING_SOON, 300)}
            alt={chipMinimizer?.name || 'chip minimizer'}
          />
        </St.ImageWrapper>
      </St.PriceWrapper>
      <p>{t('SINK_INFO_MODAL.CHIP_MINIMIZER.DESCRIPTION')}</p>
      <Form form={form} layout="vertical">
        <Form.Item>
          <CommonRadio
            defaultValue="add"
            onChange={(e) => setMinimizerOption(e.target.value)}
          >
            <Radio value="add">
              {t('SINK_INFO_MODAL.CHIP_MINIMIZER.MODIFY_BUTTON')}
            </Radio>
            <Radio value="decline">
              {t('SINK_INFO_MODAL.CHIP_MINIMIZER.DECLINE_BUTTON')}
            </Radio>
          </CommonRadio>
        </Form.Item>
      </Form>
    </St.Container>
  );
};

export default ChipMinimizerInfoContent;
